import { render, staticRenderFns } from "./bonus-table.vue?vue&type=template&id=4ba79db4&scoped=true"
import script from "./bonus-table.vue?vue&type=script&lang=js"
export * from "./bonus-table.vue?vue&type=script&lang=js"
import style0 from "./bonus-table.vue?vue&type=style&index=0&id=4ba79db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba79db4",
  null
  
)

export default component.exports